// @flow

const ANONYMOUS_USER_ID = '2';
const BYTES_IN_MB = 1048576;
const DEFAULT_MULTIPLIER = 1;
const EMPTY_VALUE = '--';

export { ANONYMOUS_USER_ID, BYTES_IN_MB, DEFAULT_MULTIPLIER, EMPTY_VALUE };
